// extracted by mini-css-extract-plugin
module.exports = {"root":"tabItem_root__MYQGf"};